import '../../styles/App.css';

export default function MiniAPI() {
        return (
            <>
                <div id="miniapi-block">
                    Couple API's listed here, all link to the overall API's documentation page.
                </div>
            </>
        )
}